<script>
  import AppPageHeader from '../../../components/main/PageHeader'

  import bus from '@utils/bus'
  import {mapGetters} from 'vuex'

  export default {
    components: {AppPageHeader},
    data () {
      return {}
    },
    computed: {
      ...mapGetters(['currentUser']),
      linkProtocoloCompeto () {
        return `https://competo.urcamp.edu.br/sou_urcamp?auth=${this.currentUser.session}`
      }
    },
    mounted () {
      bus.$emit('hide-loader')
    }
  }
</script>

<template>
    <div class="page-content">
        <app-page-header/>
        <div class="box competo-iframe-box">
            <iframe class="competo-iframe"
                    :src="linkProtocoloCompeto"
                    frameborder="0"></iframe>
        </div>
    </div>
</template>

<style lang="scss">
    .competo-iframe-box {
        min-height: calc(100vh - 210px);
    }

    .competo-iframe {
        width: 100%;
        height: calc(100vh - 230px);
    }

    @media all and (max-width: 768px) {
        .competo-iframe-box {
            min-height: calc(100vh - 175px);
        }
        .competo-iframe {
            height: calc(100vh - 195px);
        }
    }
</style>



// WEBPACK FOOTER //
// Protocolo.vue?41003f80